import PageCard from 'features/shared/components/card/PageCard';
import { renderDynamicFormFields, setDynamicFormValidationRules } from 'features/shared/forms/dynamicForm/helpers/dynamicFormHelper';
import { FormErrors, SetValidationRuleFunction } from 'features/shared/forms/hooks/useForm';
import React, { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CustomerAccountRegistrationFormBaseProps from './CustomerAccountRegistrationFormBaseProps';
import BaseFormFieldProps from 'features/shared/forms/dynamicForm/models/BaseFormFieldProps';

interface Props extends CustomerAccountRegistrationFormBaseProps {
  children: ReactNode; 
  dynamicForm: BaseFormFieldProps;
}

const CustomerAccountRegistrationFormBase = ({ children, additionalFormFields, onSubmit, showAdditionalForm, onBackClick, dynamicForm }: Props) => {
  // translations
  const tLabels = useTranslation("registration\\registration").t;

  // side-effects
  useEffect(() => {
    if (showAdditionalForm) {
      setDynamicFormValidationRules(additionalFormFields, dynamicForm.formHandler.setValidationRule);  
    }
  }, [showAdditionalForm]);

  
  // sub-renders
  const renderAdditionForm = () => {
    // formular se musi vykreslit jiz pri 1. renderu, jinak
    // se vyhazuje chyba "Rendered more hooks than during the previous render"
    // https://stackoverflow.com/questions/55622768/uncaught-invariant-violation-rendered-more-hooks-than-during-the-previous-rende
    return (
      <div className={showAdditionalForm ? undefined : "d-none"}>
        <PageCard title={tLabels("customerAccountRegistrationFormBase.additionalInformation")} bodyClassName="pt-4 px-4">
            {renderDynamicFormFields(additionalFormFields, dynamicForm)}
        </PageCard>
      </div>
    );
  };

  // render
  return (
    <>
      <PageCard title={tLabels("customerAccountRegistrationFormBase.accountRegistration")} bodyClassName="pt-4 px-4">
          {children}
      </PageCard>
      {renderAdditionForm()}
      <div className="d-flex mt-md-4">
        {onBackClick !== undefined &&
          <button className="btn btn-outline-secondary px-3 py-2 mr-3" type="button" onClick={onBackClick}>
            {tLabels("customerAccountRegistrationFormBase.backToLogin")}
          </button>
        }
        <button type="submit" className="btn btn-primary px-3 py-2">
          {tLabels("customerAccountRegistrationFormBase.sendRequest")}
        </button>
      </div>
    </>
  );
}

export default CustomerAccountRegistrationFormBase;